import styled from 'styled-components'
export const WhiteText = styled.a`
    font-family:Teko;
    color:white;
`;
export const GreyText = styled.a`
    font-family:Teko;
    color:#B2B2B2;
`;
export const DarkBorder = styled.div`
    border: #00A3FF solid 4px;
    background-color: #03527E;
    color: #00A3FF;
`;
export const Label = styled.div<{fontSize:number}>`
    border: #00A3FF solid 4px;
    background-color: #03527E;
    color: #00A3FF;
    padding: 0 3%;
    font-size:max(11vw, 38px);
    display: flex;
    align-items: center;
    height: 100%;
    position: relative;
    left: -4px;
    border-radius: 10px;
    min-width: fit-content;
`;


// WEBPACK FOOTER //
// ./src/Components/CommonStyles.ts